import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { AngularFireAuth } from '@angular/fire/compat/auth';
import firebase from 'firebase/compat/app';
import { VariablesGlobalesService } from "./variables-globales.service";

declare var gapi: any

@Injectable({
    providedIn: 'root'
})

export class GoogleCalendarService {
    afAuth = inject(AngularFireAuth);
    variablesGlobales = inject(VariablesGlobalesService);

    user$: Observable<firebase.User>;

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);
    constructor() {
        const afAuth = this.afAuth;

        //this.iniciarCliente();
        this.user$ = afAuth.authState

    }

    iniciarCliente() {
        gapi.load('client', () => {
            console.log('Cliente cargado');
            gapi.client.init({
                apiKey: 'AIzaSyCZx5bW_PhpJvilImqpT5ZTnlNIf4nwBbg',
                clientId: '822359052850-fdtf82o3uss893s1pl8jej9p9aveopv4.apps.googleusercontent.com',
                discoveryDocs: ['https://discovery.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
                scope: 'https://www.googleapis.com/auth/calendar'
            })

            gapi.client.load('calendar', 'v3', () => {
                console.log('Calendario cargado');

            })

        })
    }

    async login() {
        try {
            const googleAuth = gapi.auth2.getAuthInstance()
            const googleUser = await googleAuth.signIn()

            const token = googleUser.getAuthResponse().id_token;

            console.log('googleUser: ', googleUser);

            const credential = firebase.auth.GoogleAuthProvider.credential(token);
            console.log('Credential: ', credential);

            await this.afAuth.signInWithCredential(credential).then(() => {
                console.log('Login en google correcto.');
                this.variablesGlobales.googleLogin = true
                this.getListaCalendarios()
            });
        } catch (error) {
            console.log('Error al hacer login con google. ', error);

        }

    }

    logout() {
        gapi.auth2.getAuthInstance().disconnect();
        this.afAuth.signOut().then(async () => {
            console.log('Cerrada sesion de google');
        })
    }

    estadoGoogleAuth() {
        this.afAuth.authState.subscribe(user => {
            if (user) {
                this.variablesGlobales.googleLogin = true
                console.log('Auth usuario: ', user);
            } else {
                this.variablesGlobales.googleLogin = false
                console.log('No hay usuario auth');
            }
        })
    }

    estadoGoogleAuthObs() {
        return this.afAuth.authState
    }



    async getListaCalendarios() {
        await gapi.client.calendar.calendarList.list({
            //Param de la consulta
        }).execute(calendarListResponse => {
            console.log('Lista de calendarios: ', calendarListResponse);
            if(calendarListResponse.code && calendarListResponse.code == 401){
                this.logout()
            }else{
                this.variablesGlobales.googleListaCalendarios = calendarListResponse.items
                
            }
            
        })

    }

    getListaCalendarios2() {
        return gapi.client.calendar.calendarList.list()
    }

    async getEventosCalendario(idCalendario) {
        const events = await gapi.client.calendar.events.list({
            calendarId: idCalendario,
            //timeMin: new Date().toISOString(),
            showDeleted: false,
            singleEvents: true,
            //maxResults: 10,
            orderBy: 'startTime'
        })
        return events
    }
}